(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var container = document.querySelector('.product-recommendations-container');
  if (!container) return;

  var productId = container.dataset.productId;
  var url = '/recommendations/products?section_id=product-recommendations&limit=4&product_id=' + productId;

  fetch(url)
    .then(function(response) { return response.text(); })
    .then(function(html) {
      container.innerHTML = html;
    })
    .catch(function(error) {
      console.error('Failed to load recommendations:', error);
    });
});

  } catch(e) { console.error(e); }
})();
})();
